<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid ">
      <div class="bg-white page-border">
      <!--page body contant -->
        
        <div class="row row-replace add-m-b">
          <!-- header  -->
          <div class="col-md-6 col-p h5">DASHBOARD / EMPLOYEE MASTER </div>
            <div class="col-md-6 top-corner-items col-p"> 
               
            </div>
       </div>
  
       

        <div class="row row-replace">
            <div class="col-12 col-pn">
               <div class="card card-table flex-fill">
                  <div class="card-header">
                     <h3 class="card-title mb-0">EMPLOYEE DETAILS</h3>
                  </div>
                  <div class="card-body">
                     <div class="table-responsive">
                        <table class="table custom-table mb-0 text-center">
                           <thead>
                              <tr>
                                 <th>Photo</th>
                                 <th>EmployeeID</th>
                                 <th>First Name</th>
                                 <th>Last Name</th>
                                 <th>Email id</th>
                                 <th>Department</th>
                                 <th>Title</th>
                                 <th>Date of joining</th>
                                 <th>Work Location</th>
                                 <th>Work Phone</th>
                                 <th>Extension</th>
                                 <th>Other Email</th>
                                 <th>Reporting To</th>
                                 <th>Birth Date</th>
                                 <th>Mobile Phone</th>
                                 <th>Address</th>
                                 <th>Employee Status</th>
                                 <th>Employee Type</th>
                                 <th>Source of Hire</th>
                                 <th>Marital Status</th>
                                 <th>Employee Role</th>
                                 <th>AboutMe</th>
                                 <th>Tags</th>
                                 <th>Nick Name</th>
                                 <th>Job Description</th>
                                 <th>Ask me about/Expertise</th>
                                 <th>Date of exit</th>
                                 <th>Gender</th>
                                 <th>Age</th>
                                 <th>Experience</th>
                                 <th>Added By</th>
                                 <th>Added Time</th>
                                 <th>Modified By</th>
                                 <th>Modified time</th>
                                 
                              </tr>
                           </thead>
                           <tbody>
                            <td><a href="#" class="avatar"><img alt="" src="public/img/profiles/avatar-19.jpg"></a></td>
                            <td><a [routerLink]="['/dashboard/employeeprofile']">1100214</a></td>
                            <td>First Name</td>
                            <td>Last Name</td>
                            <td>Email id</td>
                            <td>Department</td>
                            <td>Title</td>
                            <td>Date of joining</td>
                            <td>Work Location</td>
                            <td>Work Phone</td>
                            <td>Extension</td>
                            <td>Otder Email</td>
                            <td>Reporting To</td>
                            <td>Birtd Date</td>
                            <td>Mobile Phone</td>
                            <td>Address</td>
                            <td>Employee Status</td>
                            <td>Employee Type</td>
                            <td>Source of Hire</td>
                            <td>Marital Status</td>
                            <td>Employee Role</td>
                            <td>AboutMe</td>
                            <td>Tags</td>
                            <td>Nick Name</td>
                            <td>Job Description</td>
                            <td>Ask me about/Expertise</td>
                            <td>Date of exit</td>
                            <td>Gender</td>
                            <td>Age</td>
                            <td>Experience</td>
                            <td>Added By</td>
                            <td>Added Time</td>
                            <td>Modified By</td>
                            <td>Modified time</td>
                              
                           </tbody>
                        </table>
                     </div>
                  </div>
                  
               </div>
            </div>
         </div>
         <!--end table -->




        


       
      <!--end page body contant -->
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  